import React from 'react';
import ScrollView, { ScrollElement } from './Scroller';
import ListItem from '../ListItem';
import axios from 'axios';
import { BiChevronRight, BiChevronLeft, BiChevronsDown } from 'react-icons/bi';
import Pagination from "./Pagination";
import RegisterOverlay from '../RegisterOverlay';

export default class List extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      elements: props.elements,
      currentPage: 1,
      indexOfFirstElementInWindow: 0
    };

    this.MAX_NUMBER_OF_ELEMENTS_IN_WINDOW = 3;

    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.getIsMobile = this.getIsMobile.bind(this);
    if(props.shouldPaginate && props.pageSize){
      this.setCurrentPage =  this.setCurrentPage.bind(this);

      this.state.currentListData = () => {
        const firstPageIndex = (this.state.currentPage - 1) * props.pageSize;
        const lastPageIndex = firstPageIndex + props.pageSize;
        return props.elements.slice(firstPageIndex, lastPageIndex);
      };
    }
  }

  nextPage() {
    let { currentPage, indexOfFirstElementInWindow } = this.state;
    let { elements } = this.props;
    indexOfFirstElementInWindow = Math.min(indexOfFirstElementInWindow + this.MAX_NUMBER_OF_ELEMENTS_IN_WINDOW, elements.length - 1);

    if (elements.length < this.props.totalElements) {
      currentPage++;
      this.props.loadMore(currentPage, () => {
        this.setState({
          currentPage,
          indexOfFirstElementInWindow
        });
      });

    } else {
      this.setState({
        indexOfFirstElementInWindow
      });
    }
    if (!this.getIsMobile()) {
      this._scroller.scrollTo(this.props.elements[indexOfFirstElementInWindow].slug);
    }
  }

  setCurrentPage = (page) => {
    this.setState({
      currentPage: page,
    });
  };

  previousPage() {
    let indexOfFirstElementInWindow = Math.max(this.state.indexOfFirstElementInWindow - this.MAX_NUMBER_OF_ELEMENTS_IN_WINDOW, 0);
    if (!this.getIsMobile()) {
      this._scroller.scrollTo(this.props.elements[indexOfFirstElementInWindow].slug);
    }
    this.setState({
      indexOfFirstElementInWindow
    });
  }

  getIsMobile() {
    return this.props.viewportWidth < 768;
  }

  render() {
    const isMobile = this.getIsMobile();

    return <div>
      {isMobile ? (
        <div className='row mt-3 mb-4 relative'>
          {this.props.showRegisterOverlay && (
              <RegisterOverlay />
          )}

          {(this.props.shouldPaginate && this.props.pageSize) ? (
              <>
                {this.state.currentListData().map((el, index) =>
                    <div key={index}>
                      {this.props.listItem ? this.props.listItem(el) : (
                          <ListItem
                              imageUrl={el.thumbnail_url}
                              title={el.title}
                              isHorizontalScroll={!isMobile}
                              date={el.youtube_published_at}
                              link={'/on-demand/watch/' + el.slug}
                              itemIsLocked={!this.props.isLoggedIn && el.is_locked}
                              videoDuration={el.video_duration ?? ''}
                          />
                      )}
                    </div>
                )}
                <Pagination
                    className="pagination-bar"
                    currentPage={this.state.currentPage}
                    totalCount={this.props.elements.length}
                    pageSize={this.props.pageSize}
                    onPageChange={this.setCurrentPage}
                />
              </>) : (
              <>
                  {this.props.elements.map((el, index) =>
                      <div key={index}>
                        {this.props.listItem ? this.props.listItem(el) : (
                            <ListItem
                                imageUrl={el.thumbnail_url}
                                title={el.title}
                                isHorizontalScroll={!isMobile}
                                date={el.youtube_published_at}
                                link={'/on-demand/watch/' + el.slug}
                                itemIsLocked={!this.props.isLoggedIn && el.is_locked}
                                videoDuration={el.video_duration ?? ''}
                            />
                        )}
                      </div>
                  )}
                  {this.state.currentPage < this.props.lastPage && (
                      <button
                          className='flex justify-center items-center text-sm'
                          onClick={this.nextPage}
                      >
                        <BiChevronsDown /> Load More
                      </button>
                  )}
              </>)}
        </div>) : (<div style={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      }}>
        {this.props.showRegisterOverlay && (
            <RegisterOverlay />
        )}
        
        {!this.props.showRegisterOverlay && this.state.indexOfFirstElementInWindow > 0 && (
            <button
              onClick={this.previousPage}
              style={{
                position: 'absolute',
                marginBottom: 50,
                left: -30,
                zIndex: 2
              }}
              className='cursor-pointer justify-center flex flex-row items-center select-none btn-circle w-12 h-12 rounded-full bg-neutral border-none shadow p-0'>
              <BiChevronLeft size='24px' />
            </button>
        )}

        <ScrollView ref={scroller => this._scroller = scroller}>
          <div className='ScrollListView gap-x-4 w-full' style={{
            display: 'flex',
            overflowX: 'scroll',
            overflowY: 'hidden'
          }}>
            {this.props.elements.map((el, index) =>
              <ScrollElement name={el.slug} key={index}>
                <div className={`flex-shrink-0 ${this.props.width ? this.props.width : 'w-1/2 md:w-1/3'}`}>
                  {this.props.listItem ? this.props.listItem(el) : (
                    <ListItem
                      imageUrl={el.thumbnail_url}
                      title={el.title}
                      isHorizontalScroll={!isMobile}
                      date={el.youtube_published_at}
                      link={'/on-demand/watch/' + el.slug}
                      itemIsLocked={!this.props.isLoggedIn && el.is_locked}
                      videoDuration={el.video_duration ?? ''}
                    />
                  )}
                </div>
              </ScrollElement>
            )}
          </div>
        </ScrollView>
        {!this.props.showRegisterOverlay && 
          ((this.state.indexOfFirstElementInWindow + this.MAX_NUMBER_OF_ELEMENTS_IN_WINDOW) < this.props.elements.length || this.state.currentPage < this.props.lastPage) &&
          (
            <button
              onClick={this.nextPage}
              style={{
                position: 'absolute',
                marginBottom: 50,
                right: -30
              }}
              className='cursor-pointer justify-center flex flex-row items-center select-none btn-circle w-12 h-12 rounded-full bg-neutral border-none shadow p-0'>
              <BiChevronRight size='24px' />
            </button>
        )}
      </div>)}
    </div>;
  }
}